import { Pipe, PipeTransform } from '@angular/core';
import { ISimpleObject } from '../model/ISimpleObject';

@Pipe({
  name: 'filtervalues'
})
export class FilterValuesPipe implements PipeTransform {

  transform(items: ISimpleObject[], filterVal: string) {
    if (items) {
      return items.filter(i => i.Name.toLowerCase().indexOf(filterVal.toLowerCase()) >= 0 || i.Text.toLowerCase().indexOf(filterVal.toLowerCase()) >= 0);
    }
  }
}
